module.exports = __webpack_public_path__ + "media/images/temp/ribbon-1-002d0822486a7881fa77ac06be8e7c69.png";